var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tv-inner tv-video",
      class: {
        beforeplay: !_vm.played,
        paused: !_vm.playing,
        playing: _vm.playing,
        interactive: _vm.interactive
      },
      on: {
        mouseover: _vm.resetInteractive,
        mousemove: _vm.resetInteractive,
        click: _vm.resetInteractive
      }
    },
    [
      _c("div", { staticClass: "video-container" }, [
        _c("video", {
          ref: "video",
          attrs: { poster: _vm.poster, loop: _vm.loop }
        }),
        _vm._v(" "),
        _c("video", {
          ref: "introoutro",
          staticClass: "introoutro",
          class: { ply: _vm.introOutroPlaying }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "logo" }),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "seekbar",
          staticClass: "seek-bar",
          on: {
            mousedown: function($event) {
              $event.preventDefault()
              return _vm.dragStart($event)
            }
          }
        },
        [
          _c("div", {
            staticClass: "seek-progress",
            style: { width: (_vm.time / _vm.duration) * 100 + "%" }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "seek-line",
              style: { width: (_vm.time / _vm.duration) * 100 + "%" }
            },
            [
              _c("span", { staticClass: "current" }, [
                _vm._v(_vm._s(_vm.formatTime(this.time)))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "duration" }, [
                _vm._v(_vm._s(_vm.formatTime(this.duration)))
              ])
            ]
          ),
          _vm._v(" "),
          _vm.chapters
            ? _c(
                "ul",
                { staticClass: "chapters" },
                _vm._l(_vm.chapters, function(chapter) {
                  return _c("li", {
                    class: { "not-passed": !chapter.passed },
                    style: { left: _vm.calcLeft(chapter.time) }
                  })
                }),
                0
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "video-description" }, [
        _c("div", { staticClass: "tvd-in" }, [_vm._t("default")], 2)
      ]),
      _vm._v(" "),
      _c("a", {
        staticClass: "playpause",
        attrs: { href: "" },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.playpause($event)
          }
        }
      }),
      _vm._v(" "),
      !_vm.edit
        ? _c("volume-bar", {
            model: {
              value: _vm.volume,
              callback: function($$v) {
                _vm.volume = $$v
              },
              expression: "volume"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.edit
        ? _c("div", { staticClass: "fullsc" }, [
            _c("a", {
              staticClass: "fs-toggle",
              class: { active: _vm.isFullScreen },
              attrs: { href: "" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.toggleFullscreen($event)
                }
              }
            })
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }